// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"boela0","input":"NsEfZI","checkmarkBorder":"o_8Fl1","active":"xkmzQt","checkmark":"_tskZR","show":"lRgXmv","label":"evHKWO"};